<div class="p-g-6 p-md-12">
  <div class="activity-box">
    <div class="p-g activity-header-area">
      <div class="p-g-6 p-g-nopad">
        <h4 class="activity-header">{{headerLHS}}</h4>
      </div>
      <div class="p-g-6 p-g-nopad">
        <h4 class="show-all-notifs" (click)="viewAllNotifications()">View All</h4>
      </div>
    </div>
    <div class="activity-body-area" style="overflow: hidden;">
      <div class="p-g-12">
        <div class="p-g-12 gridparent">
          <app-mi-grid [defaultTheme]="gridTheme"
            [serialNo]="showSerialNo" [exportUrl]="exportUrl" [printUrl]="printUrl" [pagination]="false" [paginationPageSize]="5"></app-mi-grid>
        </div>
      </div>
    </div>
  </div>
</div>
